import { stripHtml } from 'string-strip-html';

const cache = new Map<string, string>();

export function cachedStripHtml(input: string): string {
  const cached = cache.get(input);
  if (cached !== undefined) return cached;
  const result = stripHtml(input).result.trim();
  cache.set(input, result);
  return result;
}

export function clearStripHtmlCache(): void {
  cache.clear();
}
